
import React, { useState } from 'react';
import { View, Merchant, SampleRecord, MealType } from './types';
import Dashboard from './views/Dashboard';
import RecordsView from './views/RecordsView';
import SamplingView from './views/SamplingView';
import { Layout } from './components/Layout';

const INITIAL_MERCHANTS: Merchant[] = Array.from({ length: 6 }, (_, i) => ({
  id: `m${i + 1}`,
  name: `商户${i + 1}`,
  counts: {
    [MealType.Breakfast]: 12,
    [MealType.Lunch]: 10,
    [MealType.Dinner]: 12,
    [MealType.LateNight]: 10,
  }
}));

const INITIAL_RECORDS: SampleRecord[] = [
  {
    id: 'r1',
    merchantId: 'm1',
    dishName: '辣椒炒肉',
    weight: 128,
    samplingTime: '2026-01-14 07:12:13',
    expiryTime: '2026-01-16 07:12:13',
    sampler: '张三',
    mealType: MealType.Breakfast,
    photoUrl: 'https://picsum.photos/seed/dish1/200/200',
    chef: '李大厨'
  }
];

const App: React.FC = () => {
  const [currentView, setCurrentView] = useState<View>('dashboard');
  const [selectedMerchantId, setSelectedMerchantId] = useState<string | null>(null);
  const [merchants, setMerchants] = useState<Merchant[]>(INITIAL_MERCHANTS);
  const [records, setRecords] = useState<SampleRecord[]>(INITIAL_RECORDS);

  const navigateTo = (view: View, merchantId?: string) => {
    if (merchantId) setSelectedMerchantId(merchantId);
    setCurrentView(view);
  };

  const handleAddSample = (newRecord: SampleRecord) => {
    setRecords(prev => [newRecord, ...prev]);
    setMerchants(prev => prev.map(m => {
      if (m.id === newRecord.merchantId) {
        return {
          ...m,
          counts: { ...m.counts, [newRecord.mealType]: m.counts[newRecord.mealType] + 1 }
        };
      }
      return m;
    }));
  };

  const selectedMerchant = merchants.find(m => m.id === selectedMerchantId) || merchants[0];

  return (
    <Layout>
      {currentView === 'dashboard' && (
        <Dashboard 
          merchants={merchants} 
          onMerchantClick={(id) => navigateTo('records', id)}
          onStartSampling={() => navigateTo('sampling')}
        />
      )}
      {currentView === 'records' && selectedMerchant && (
        <RecordsView 
          merchant={selectedMerchant}
          records={records.filter(r => r.merchantId === selectedMerchant.id)}
          onBack={() => setCurrentView('dashboard')}
        />
      )}
      {currentView === 'sampling' && (
        <SamplingView 
          merchants={merchants}
          onCancel={() => setCurrentView('dashboard')}
          onSubmit={handleAddSample}
          initialMerchantId={selectedMerchantId || undefined}
        />
      )}
    </Layout>
  );
};

export default App;
